import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './contexts/ProtectedRoute';
import CheckCredits from './contexts/CheckCredits';
import './components/Reports/ReportStyles.css';
import Nav from './pages/Nav';
import Home from './pages/Home';
import Report from './pages/Report';
import Playground from './pages/Playground';
//import Pricing from './pages/Pricing';
import Unsubscribe from './pages/Unsubscribe';
import Login from './pages/Login';
import Account from './pages/Account';
import Confirmation from './pages/Confirmation';
import { gaPageview } from './utils/analytics';
import './App.css';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    gaPageview();
  }, [location]);

  return (
    <div className="App">
      <Nav />
      <div className="page-container scrollable-compact">
        <Routes>
          <Route path="/" element={<Home />} />
          {/*<Route path="/pricing" element={<Pricing />} />*/}
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
            
          } />
          <Route path="/report" element={
            <ProtectedRoute>
              <CheckCredits>
              <Report />
              </CheckCredits>
            </ProtectedRoute>
          } />
          <Route path="/playground" element={
            <ProtectedRoute>  
              <CheckCredits>
              <Playground />
              </CheckCredits>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;